export default __webpack_public_path__ + "static/media/eb-arrow-r.5b5c79b9.svg";